/**
 *
 * CloseButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Button } from 'react-bootstrap';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

function CloseButton(props) {
  const { onClose, message } = props;
  return (
    <Button className="close" onClick={onClose}>
      <span aria-hidden="true">×</span>
      <span className="sr-only">
        <FormattedMessage {...message || messages.label} />
      </span>
    </Button>
  );
}

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.object,
};

export default CloseButton;
